import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DatastoreShowcaseModule } from '@freelancer/datastore/collections';
import { TrackingModule } from '@freelancer/tracking';
import { UiModule } from '@freelancer/ui';
import { DiscoverManageDeleteModalComponent } from './discover-manage-delete-modal.component';

@NgModule({
  imports: [CommonModule, TrackingModule, UiModule, DatastoreShowcaseModule],
  declarations: [DiscoverManageDeleteModalComponent],
})
export class DiscoverManageDeleteModalModule {}
